module.exports = __webpack_public_path__ + "img/empty_deliveries.96508b17.png";